import { render, staticRenderFns } from "./AddToPhoneInfo.vue?vue&type=template&id=2f94bf26&scoped=true&"
import script from "./AddToPhoneInfo.vue?vue&type=script&lang=js&"
export * from "./AddToPhoneInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddToPhoneInfo.vue?vue&type=style&index=0&id=2f94bf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94bf26",
  null
  
)

export default component.exports